module.exports = __webpack_public_path__ + "static/media/009-firefighter.8f447c6c.svg";